/**
* Logo Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logo Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'logo-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.logo-marquee__marquee' ).length ) {
        const splide = new Splide( '.logo-marquee__marquee', {
          type: 'loop',
          drag: 'free',
          focus: 'center',
          gap: '-2rem',
          arrows: false,
          pagination: false,
          autoWidth: true,
        } );
        splide.mount( {AutoScroll} );
        // $( '.logo-marquee__marquee' ).each( function( index, element ) {

        // } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logo-marquee', COMPONENT );
} )( app );
